/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    Validator,
    ValidatorFromJSON,
    ValidatorFromJSONTyped,
    ValidatorToJSON,
    ValidatorAggStats,
    ValidatorAggStatsFromJSON,
    ValidatorAggStatsFromJSONTyped,
    ValidatorAggStatsToJSON,
    ValidatorListAllOf,
    ValidatorListAllOfFromJSON,
    ValidatorListAllOfFromJSONTyped,
    ValidatorListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidatorList
 */
export interface ValidatorList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof ValidatorList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof ValidatorList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Validator>}
     * @memberof ValidatorList
     */
    validators: Array<Validator>;
    /**
     * Summary statistics across all consensus validators.
     * @type {ValidatorAggStats}
     * @memberof ValidatorList
     */
    stats: ValidatorAggStats;
}

export function ValidatorListFromJSON(json: any): ValidatorList {
    return ValidatorListFromJSONTyped(json, false);
}

export function ValidatorListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'validators': ((json['validators'] as Array<any>).map(ValidatorFromJSON)),
        'stats': ValidatorAggStatsFromJSON(json['stats']),
    };
}

export function ValidatorListToJSON(value?: ValidatorList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'validators': ((value.validators as Array<any>).map(ValidatorToJSON)),
        'stats': ValidatorAggStatsToJSON(value.stats),
    };
}


